var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('notifications'),_c('side-bar',[_c('template',{slot:"links"},[_c('sidebar-item',{attrs:{"link":{
          name: 'Dashboard',
          path: '/admin/dashboard',
          icon: 'ni ni-tv-2 text-purple',
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Agências',
          path: '/admin/agencias',
          icon: 'ni ni-building text-danger',
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Peças Publicitárias',
          path: '/admin/pecas-publicitarias',
          icon: 'ni ni-single-copy-04 text-danger',
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Estudantes',
          path: '/admin/estudantes',
          icon: 'ni ni-hat-3 text-info',
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Peças Estudantes',
          path: '/admin/pecas-estudantes',
          icon: 'ni ni-single-copy-04 text-info',
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Resposta de Jurado',
          path: '/admin/jurado-resposta',
          icon: 'ni ni-badge text-purple',
        }}})],1),_c('template',{slot:"links-after"},[_c('sidebar-item',{attrs:{"link":{
          name: 'Categoria Peça Publicitária',
          path: '/admin/categoria-peca-publicitaria',
          icon: 'ni ni-bullet-list-67 text-danger',
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Categoria Peça Estudante',
          path: '/admin/categoria-peca-estudante',
          icon: 'ni ni-bullet-list-67 text-warning',
        }}})],1),_c('template',{slot:"links-legado"},[_c('sidebar-item',{attrs:{"link":{
          name: 'Indicação de Profissionais (legado)',
          path: '/admin/profissionais',
          icon: 'ni ni-briefcase-24 text-success',
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Profissionais Independentes (legado)',
          path: '/admin/profissional-independente',
          icon: 'ni ni-briefcase-24 text-success',
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Peças de Profissionais Independentes (legado)',
          path: '/admin/pecas-profissional-independente',
          icon: 'ni ni-single-copy-04 text-success',
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Fornecedores (legado)',
          path: '/admin/fornecedores',
          icon: 'ni ni-bag-17 text-warning',
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Peças Fornecedores (legado)',
          path: '/admin/pecas-fornecedores',
          icon: 'ni ni-single-copy-04 text-warning',
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Categoria Peça Fornecedor (legado)',
          path: '/admin/categoria-peca-fornecedor',
          icon: 'ni ni-bullet-list-67 text-warning',
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Categoria Peça Profissional Independente (legado)',
          path: '/admin/categoria-peca-profissional-independente',
          icon: 'ni ni-bullet-list-67 text-warning',
        }}})],1)],2),_c('div',{staticClass:"main-content"},[_c('dashboard-navbar',{attrs:{"type":_vm.$route.meta.navbarType}}),_c('div',{on:{"click":function($event){return _vm.$sidebar.displaySidebar(false)}}},[_c('fade-transition',{attrs:{"duration":200,"origin":"center top","mode":"out-in"}},[_c('router-view')],1)],1),(!_vm.$route.meta.hideFooter)?_c('content-footer'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }